import styled from 'styled-components'

export const Line = styled.line`
  fill:none;
  stroke: ${p => p.stroke};
  stroke-width:2px;
`